<template>
  <transition name="modal">
    <div v-if="isVisible" class="modal-mask" @click.self="closeModal">
      <div class="modal-container">
        <div class="modal-content">
          <!-- 网站LOGO上传 -->
          <div class="modal-row">
            <label>网站LOGO</label>
            <el-upload
              class="avatar-uploader"
              action="#"
              :show-file-list="false"
              :before-upload="beforeAvatarUpload"
              :http-request="handleAvatarUpload"
              accept="image/*"
              :auto-upload="true"
            >
              <img
                v-if="localSysConfigInfo.websiteImg"
                :src="localSysConfigInfo.websiteImg"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </div>

          <!-- 网站名称 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>网站名称</label>
            </div>
            <div class="column">
              <el-input
                v-model="localSysConfigInfo.websiteName"
                placeholder="请输入网站名称"
              ></el-input>
            </div>
          </div>

          <!-- 网站描述 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>网站描述</label>
            </div>
            <div class="column">
              <el-input
                v-model="localSysConfigInfo.websiteDesc"
                placeholder="请输入网站描述"
                type="textarea"
                :rows="1"
              ></el-input>
            </div>
          </div>

          <!-- 网站版本 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>网站版本</label>
            </div>
            <div class="column">
              <el-input
                v-model="localSysConfigInfo.websiteVersion"
                placeholder="请输入网站版本号"
              ></el-input>
            </div>
          </div>

          <!-- 网站备案号 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>网站备案号</label>
            </div>
            <div class="column">
              <el-input
                v-model="localSysConfigInfo.websiteBeian"
                placeholder="请输入网站备案号"
              ></el-input>
            </div>
          </div>

          <!-- 运行环境标题 -->
          <div class="modal-row two-columns">
            <div class="column">
              <label>故事页标题</label>
            </div>
            <div class="column">
              <el-input
                v-model="localSysConfigInfo.lifeTitle"
                placeholder="请输入故事页标题"
              ></el-input>
            </div>
          </div>

          <!-- 操作按钮 -->
          <div class="modal-row button-row">
            <el-button @click="closeModal">关闭窗口</el-button>
            <el-button @click="clearForm">清空数据</el-button>
            <el-button type="primary" @click="submitForm">提交配置</el-button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { Message } from 'element-ui';
import { updateConfig } from '@/api/config';
import config from "@/utils/Config";

// 你的文件前缀（这里改成你真实的）

export default {
  name: 'SysConfig',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    sysConfigInfo: {
      type: Object,
      default: () => ({
        id: null,
        websiteName: '',
        websiteDesc: '',
        websiteVersion: '',
        websiteBeian: '',
        websiteImg: '',
        lifeTitle: ''
      })
    }
  },
  data() {
    return {
      localSysConfigInfo: {
        ...this.sysConfigInfo,
        imageFile: null
      }
    };
  },
  watch: {
    sysConfigInfo: {
      handler(val) {
        this.localSysConfigInfo = {
          ...val,
          imageFile: null
        };

        // ==============================================
        // 🔥 编辑回显时：自动拼接图片前缀
        // ==============================================
        if (val.id && val.websiteImg) {
          // 如果是编辑模式，并且有图片
          if (!val.websiteImg.startsWith('http')) {
            this.localSysConfigInfo.websiteImg = config.BASE_FILE_URL + val.websiteImg;
          }
        }

      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    closeModal() {
      this.clearForm();
      this.$emit('update:visible', false);
    },
    clearForm() {
      this.localSysConfigInfo = {
        id: null,
        websiteName: '',
        websiteDesc: '',
        websiteVersion: '',
        websiteBeian: '',
        websiteImg: '',
        lifeTitle: '',
        imageFile: null
      };
    },
    beforeAvatarUpload(file) {
      const isImage = file.type.includes('image/');
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isImage) {
        Message.error('只能上传图片文件！');
        return false;
      }
      if (!isLt10M) {
        Message.error('图片大小不能超过10MB！');
        return false;
      }
      return true;
    },
    handleAvatarUpload({ file }) {
      const reader = new FileReader();
      reader.onload = (e) => {
        // 选择新图片 → 直接用本地预览，不再拼接前缀
        this.localSysConfigInfo.websiteImg = e.target.result;
        this.localSysConfigInfo.imageFile = file;
        this.$forceUpdate();
        Message.success('图片选择成功，已预览');
      };
      reader.readAsDataURL(file);
    },
    async submitForm() {
      if (!this.localSysConfigInfo.websiteName) {
        Message.error('请填写网站名称');
        return;
      }

      const formData = new FormData();
      let finalImgUrl = this.localSysConfigInfo.websiteImg;

      // ==============================================
      // 🔥 提交时：如果是拼接过的前缀，自动去掉！
      // ==============================================
      if (finalImgUrl.startsWith(config.BASE_FILE_URL)) {
        finalImgUrl = finalImgUrl.replace(config.BASE_FILE_URL, '');
      }

      const configDto = {
        id: this.localSysConfigInfo.id,
        websiteName: this.localSysConfigInfo.websiteName,
        websiteDesc: this.localSysConfigInfo.websiteDesc,
        websiteVersion: this.localSysConfigInfo.websiteVersion,
        websiteBeian: this.localSysConfigInfo.websiteBeian,
        websiteImg: finalImgUrl, // 🔥 这里传去掉前缀的真实路径
        lifeTitle: this.localSysConfigInfo.lifeTitle
      };

      formData.append('sysConfig', JSON.stringify(configDto));

      if (this.localSysConfigInfo.imageFile) {
        formData.append('file', this.localSysConfigInfo.imageFile);
      }

      const configParams = {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
      try {
        const resp = await updateConfig(formData, configParams);
        if (resp.code === 200) {
          Message.success('系统配置保存成功！');
          this.$emit('saved');
          this.closeModal();
        } else {
          Message.error(resp.msg || '保存失败');
        }
      } catch (err) {
        Message.error('请求失败：' + (err.message || err));
      }
    }
  }
};
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  transition: opacity 0.3s ease;
}

.modal-container {
  width: 55%;
  min-height: 60%;
  background-color: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(16px) saturate(180%);
  -webkit-backdrop-filter: blur(16px) saturate(180%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  display: flex;
  flex-direction: column;
  padding: 20px;
}

@media (max-width: 768px) {
  .modal-container {
    width: 90% !important;
    padding: 6px !important;
  }
}

.modal-content {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.modal-row {
  margin-bottom: 20px;
}

.two-columns {
  display: flex;
  align-items: center;
}

.column {
  flex: 1;
}

.column:first-child {
  margin-right: 15px;
  min-width: 110px;
  font-weight: 500;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: auto;
  padding-top: 15px;
  border-top: 1px solid #eee;
}

.button-row button {
  margin-left: 10px;
}

.avatar-uploader {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 178px;
  height: 178px;
}

.avatar-uploader:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
  object-fit: cover;
}

.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}

.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  transform: scale(0.9);
}
</style>